import Search from './Search';
import { UserIsAuthenticated, siteTitle } from '../';

const SearchRoutes = {
		search: {
				path: '/search/',
				label: 'Search',
				title: `${siteTitle} - Search`,
				component: UserIsAuthenticated(Search)
		}
};

export { SearchRoutes, Search };



// WEBPACK FOOTER //
// ./src/app/containers/Search/index.ts